module.exports = {
	"en-tal": {
		"ui": {
			"project": {
				"advanced_subtitle_2": "Qualification",
				"standard_title": "The standard talent sheet includes:",
				"standard_subtitle_1": "Personal",
				"standard_subtitle_2": "Company",
				"standard_description_1": "Language, Gender, Title, Name, Last name, E-mail, Position, Function, Role, Job",
				"standard_description_2": "Company name, Branch, Phone, Website, Street, Number, Postal code, State, Country",
				"advanced_title": "The advanced talent sheet includes the same tabs and fields as the standard talent sheet and in addition:",
				"advanced_description_1": "Customer enquiries, Information, E-mail marketing (newsletter, event and e-mail subscriptions)",
				"advanced_description_2": "Notes, Interested in, Campaign planned (duration in months)",
				"advanced_subtitle_1": "Campaign Appointment",
				"create_leadsheet": "Create a new talent sheet"
			},
			"segments": {
				"segments": "Segments",
				"is_editing_state": "Save the segment before proceeding",
				"add_to_project": {
					"empty": "No campaigns",
					"success": "Your contacts are being added to the campaign. This may take a few minutes.",
					"error": "Something went wrong while adding contacts to campaigns"
				},
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Created on",
					"updated": "Last updated",
					"creator": "Creator"
				},
				"actions": {
					"success": "Succesfully saved segment!",
					"error": "Could not save the segment.",
					"edit": "Edit",
					"edit_description": "Edit",
					"duplicate": "Duplicate",
					"duplicate_description": "Duplicate",
					"duplicate_name": "Copy of {name}",
					"delete": "Delete",
					"delete_description": "Delete"
				},
				"business_kit": {
					"segment_title": "Send to",
					"subtext": "Make sure your BusinessKit is set up correctly before sending",
					"contacts": "Contacts",
					"success": "Successfully sent businesskits",
					"error": "Something went wrong while sending businesskits",
					"preview": "Preview",
					"email_templates_confirmation": "Confirm that there is an email template for this BusinessKit. If an email template has not been created this BusinessKit will not be sent."
				},
				"create_modal": {
					"title": "Create segment",
					"field_label": "New segment name",
					"duplicate": "Create",
					"name": "Name"
				},
				"delete_modal": {
					"title": "Delete segment"
				},
				"duplicate_modal": {
					"title": "Duplicate segment",
					"duplicate": "Duplicate",
					"name": "New segment name"
				},
				"businesskits_modal": {
					"title": "Send out ready",
					"send": "Send Kit"
				},
				"add_to_project_modal": {
					"title": "Add to campaign",
					"search_label": "Search for campaign",
					"add_button": "Add"
				},
				"export": {
					"success": "Export complete. You should receive an email with your contacts shortly.",
					"error": "Something went wrong with the export, please try again."
				},
				"delete": {
					"success": "Contacts successfully deleted",
					"error": "One or more contacts could not be deleted"
				}
			},
			"segment": {
				"breadcrumb_back": "All segments"
			},
			"contacts": {
				"modals": {
					"delete": {
						"title": "Delete Contacts"
					}
				},
				"title": "Contacts",
				"create": "Create contact",
				"empty_state_msg": "No contacts match filters",
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Created on",
					"updated": "Last updated",
					"company": "Company",
					"source": "Source",
					"email": "Email",
					"gender": "Gender"
				},
				"actions": {
					"export": "Export",
					"save_to_project": "Add to campaign",
					"send_businesskit": "Send a businesskit",
					"error": "There has been an error updating the contact",
					"success": "The contact has been updated successfully",
					"delete": "Delete"
				},
				"filters": {
					"custom_placeholder": "Campaign attributes...",
					"general": {
						"none": "None assigned"
					},
					"project": {
						"label": "Campaign name",
						"none": "Belongs to no campaigns"
					},
					"company": {
						"label": "Company",
						"none": "Belongs to no company"
					},
					"gender": {
						"label": "Gender",
						"options": {
							"male": "Male",
							"female": "Female"
						}
					},
					"language": {
						"label": "Language",
						"options": {
							"en": "English",
							"de": "German"
						}
					},
					"invalid_email": {
						"label": "Email is valid",
						"condition_label": "Email",
						"options": {
							"valid": "valid",
							"not_valid": "not valid"
						}
					},
					"created": {
						"label": "Created"
					},
					"updated": {
						"label": "Updated"
					},
					"city": {
						"label": "City"
					},
					"country": {
						"label": "Country"
					},
					"tags": {
						"label": "Tags"
					},
					"classification": {
						"label": "Classification",
						"options": [
							{
								"value": "unclassified",
								"name": "Unclassified"
							},
							{
								"value": "hot",
								"name": "Hot"
							},
							{
								"value": "warm",
								"name": "Warm"
							},
							{
								"value": "cold",
								"name": "Cold"
							}
						]
					}
				},
				"import": {
					"title": "Import Contacts",
					"description": "Upload a CSV or XLS file containing the contacts to be imported.",
					"format": "The file should contain at least three columns: firstname, lastname and email. Only the email is mandatory but first name and last name are highly recommended.",
					"success_flash": "Contacts were successfully imported",
					"success_modal_title": "Import complete",
					"success_modal_body": "Your contacts have been successfully imported.",
					"success_modal_report": "From the {total} contacts imported, {new} new contacts were created, and {updated} were updated."
				}
			},
			"contact": {
				"edit": "Edit",
				"change_company": "Change",
				"breadcrumb_back": "All contacts",
				"empty_state_text": "This contact has not been captured as a talent yet.",
				"contact_details": "Contact details",
				"company_details": "Company details",
				"created": "Created",
				"updated": "Updated",
				"is_lead_on": "Is talent on",
				"go_to_lead": "Go to talent",
				"tags": "Tags",
				"source": "Source",
				"sources": {
					"web_app": "Web App",
					"mobile_app": "Mobile App",
					"external_form": "External Form",
					"crm_sync": "CRM Sync",
					"upload": "Upload",
					"unknown": "Unknown"
				},
				"caption": {
					"email": "Email",
					"firstname": "First Name",
					"lastname": "Last Name",
					"business_card_job_title": "Job Title",
					"company_department": "Department",
					"phone_mobile": "Mobile Phone",
					"phone_company": "Company Phone",
					"phone_private": "Private Phone",
					"gender": "Gender",
					"language": "Language"
				}
			},
			"xtable": {
				"toggle_columns": "Toggle Columns",
				"actions": "Actions",
				"page_size_label": "View",
				"search_placeholder": "Search",
				"save_search_title": "Save search",
				"save_search_label": "Name",
				"empty_state_label": "No data matches filters",
				"empty_cell_value": "No {name} assigned"
			},
			"xfilters": {
				"confirm_removal": "Yes, remove filter",
				"add_filter": "Add Filter",
				"add_filter_confirm": "Add",
				"delete_filter_warning": "You are about to remove or replace a filter condition which other conditions depend on. If you continue, then all of those dependant conditions will also be removed.",
				"delete_filter_confirmation": "Are you sure you want to continue?",
				"conditions": {
					"operators": {
						"and": "and",
						"or": "or"
					},
					"predicates": {
						"has_any": "has any of",
						"has_all": "has all of"
					},
					"summary": {
						"is": "{0} is {1}",
						"has_all": "{0} has all of {1}",
						"has_any": "{0} has any of {1}",
						"includes": "{0} includes {1}",
						"is_not_assigned": "{0} is not assigned",
						"date_on": "{0} on {1}",
						"date_between": "{0} between {1} and {2}",
						"date_since": "{0} since {1}",
						"date_before": "{0} on or before {1}",
						"date_in_range": "{0} in the {1}",
						"date_in_range_simple": "{0} {1}"
					}
				},
				"xfiltermodal": {
					"date_from": "From",
					"date_to": "To"
				},
				"date_ranges": {
					"custom": "Custom",
					"today": "Today",
					"yesterday": "Yesterday",
					"past_week": "Past week",
					"past_month": "Past month",
					"past_year": "Past year"
				}
			},
			"drag_elements": {
				"gender": "Gender/Salutation",
				"paragraph": "Paragraph",
				"title": "Title",
				"confirmation": "Confirmation",
				"firstname": "Firstname",
				"lastname": "Lastname",
				"email": "Email",
				"company": "Company",
				"street": "Street",
				"street_number": "Street number",
				"zip": "Post code",
				"city": "City",
				"country": "Country",
				"website": "Website",
				"phone_company": "Phone (Company)",
				"phone_mobile": "Phone (Mobile)",
				"textfield": "Textfield",
				"long_textfield": "Long textfield",
				"multi_select": "Multi select",
				"dropdown": "Dropdown",
				"single_select": "Single select",
				"date": "Date",
				"readonly": "Readonly",
				"quantity_selection": "Quantity selection",
				"drawing": "Drawing"
			},
			"breadcrump": {
				"back": "Back",
				"all_projects": "All campaigns"
			},
			"dashboard": {
				"filter": {
					"all_projects": "All campaigns"
				},
				"leads_collected_label": "Talents collected",
				"most_active_projects": "Most active campaigns",
				"leads_over_time": {
					"label": "Talent over time",
					"linear": "Talents"
				},
				"conversion_funnel": {
					"label": "Conversion funnel",
					"leads": "Talente"
				},
				"hot": "Hot",
				"warm": "Warm",
				"cold": "Cold",
				"unclassified": "Unclassified",
				"top_projects_label": "Top campaigns",
				"kit_activity_label": "Latest interactions",
				"latest_activity_label": "Latest activity",
				"leads_by_project_label": "Contacts by campaigns",
				"leads_by_most_active_projects_label": "Talents by most active Campaign",
				"leads_by_most_active_projects": {
					"me": "Me",
					"org": "Org"
				},
				"empty_state_headline": "The dashboard will show up once there is enough date",
				"empty_state_intro": "Start creating your first content",
				"empty_state_cta": "Create a campaign",
				"top_sources_label": "Top sources",
				"active_leads": {
					"label": "Most active contacts",
					"today": "Today",
					"last_7": "Last 7 days",
					"last_month": "Last month",
					"last_year": "Last year",
					"all_time": "All time"
				},
				"leads_over_time_label": "Contacts over time",
				"axischart": {
					"last_week": "Last week",
					"last_month": "Last month",
					"last_year": "Last year"
				},
				"top_projects": {
					"kits": "Kits",
					"leads": "Talente",
					"my_leads": "My Talents",
					"lead_sheet": "Talent sheet"
				},
				"top_sources": {
					"last_week": "Last week",
					"last_month": "Last month",
					"last_year": "Last year",
					"web_app": "Web app",
					"external_forms": "External forms",
					"mobile_app": "Mobile app"
				},
				"kit_activity": {
					"all": "All",
					"opened_a_kit": "opened a kit",
					"updated_a_lead": "updated a contact",
					"empty_state_headline": "No kit activity yet",
					"empty_state_intro": "Create an engaging and personalized content experience that helps genuinely connect with your company."
				},
				"latest_activity": {
					"label": "Newest Talents"
				},
				"activity_list_widget": {
					"created_a_lead": "created a contact",
					"updated_a_lead": "updated a contact",
					"on": "on",
					"latest_activity": "Latest activity",
					"empty_state_headline": "No activity yet",
					"empty_state_intro": "Start a campaign"
				}
			},
			"meta_info": {
				"invitation": "Welcome to Talent",
				"reset_password": "Reset your password"
			},
			"email_template": {
				"placeholders": {
					"firstname": "Firstname",
					"lastname": "Last name",
					"formal": "Formal salutation",
					"informal": "Informal salutation",
					"gender": "Mr/Mrs",
					"form_title": "Form title"
				}
			},
			"external_form": {
				"preview_page": {
					"title": "Embed",
					"head_paragraph": "To include the form on your website, please load the following script into your <head> tag.",
					"html_paragraph": "Then insert the form via html tag where you want it to appear on your page.",
					"script_paragraph": "Then load the form via Javascript.",
					"head_section_title": "Head",
					"html_section_title": "HTML",
					"script_section_title": "Script",
					"forms_cannot_be_submitted": "Please note that forms cannot be submitted in preview mode. You can easily control the form styling via the page on which you embed it."
				},
				"follow_up": "Follow up actions",
				"tabs": {
					"general": "General",
					"config": "Configuration",
					"editor": "Editor",
					"preview": "Preview"
				},
				"add_element": "Add an element",
				"add_container": "Add a container",
				"add_field": "Add a field",
				"preview": "Preview form",
				"empty": "None",
				"fileds": "Talentmask fields",
				"basic_config": "Basic configuration",
				"lead_mask_field": "Talent sheet field",
				"form_editor": "Form editor",
				"frontend_actions": "Action when visitor submits the form:",
				"backend_actions": "Follow up actions:",
				"bk_boarding": "Talentkit boarding",
				"send_directly": "Send the Talentkit manually?",
				"email_notification": "Notification by email",
				"add_to_mailchimp": "Add to a mailchimp list",
				"field_assignation": "Field assignments",
				"board_bk": "Board a Talentkit",
				"success_message": "Success message",
				"redirection_url": "Redirect URL",
				"send_notification_to": "Send notifications to email adresses:",
				"mailchimp_list_id": "Mailchimp list id",
				"board_citrix": "Board Citrix",
				"citrix_keys": "Citrix webinar keys",
				"send_lead_confirmation_mail": "Send notification mail to talent",
				"email_template": "Email template",
				"mail_subject": "Email subject",
				"mail_url": "CTA URL",
				"mail_cta": "CTA text"
			},
			"lead_mask_editor": {
				"see_raw": "See talent sheet raw content",
				"edit_element": "Edit an element",
				"delete_element": "Delete element",
				"title": "Title",
				"cancel": "Cancel",
				"valid": "Confirm",
				"chose_element": "Please choose an element",
				"name": "Name",
				"type": "Type",
				"content": "Content",
				"field": "Field",
				"default_value": "Default value",
				"default_field": "Default field",
				"element_width": "Element width",
				"required": "Required",
				"class": "Class",
				"label": "Label",
				"placeholder": "Placeholder",
				"children": "Children",
				"displayed_name": "Displayed name",
				"value": "Value",
				"add_line": "Add a line",
				"collection": "Collection",
				"delete": "Delete",
				"set_default_value": "Set as default value",
				"basic_config": "Grundeinstellungen",
				"tabs": {
					"general": "General",
					"editor": "Editor"
				}
			},
			"auth": {
				"button": "Login",
				"confirm": "Set password",
				"create_account_subtitle": "Setup your password below",
				"create_account_subtitle_confirm": "You have setup your account successfully. Please login to Talent now.",
				"create_account_title": "Create your account",
				"create_account_title_confirm": "Congratulations",
				"email": "Email address",
				"firstname": "First Name",
				"go_to_login": "To the login",
				"password": "Password",
				"password_confirmation": "Confirm password",
				"password_reset": "Password forgotten ?",
				"password_reset_request_title": "Reset your password",
				"password_reset_request_title_confirm": "Check your email inbox",
				"password_reset_sent": "An email with a password reset link has been sent to the given email if it exists.",
				"password_reset_title": "Password reset",
				"password_reset_title_confirm": "Congratulations",
				"lastname": "Last Name",
				"return_to_login": "Get back to login page",
				"success": "Your password has been set successfully. You can now login into the Fanomena Talent products.",
				"user_not_found": "User not found",
				"user_not_found_subtitle": "We're sorry but the user you are trying to access was not found in our system.<br/>Maybe your invitation link has expired or the user has been deleted."
			},
			"auth_illustration": {
				"contact_us": "Contact us",
				"get_access": "Get your access",
				"invitation_subtitle": "Explore your opportunities",
				"invitation_title": "Want to know more about Fanomena Talent?",
				"login_subtitle": "Let us show you Fanomena Talent",
				"login_title": "New here and want to look around?",
				"reset_request_subtitle": "Let us help you",
				"reset_request_title": "Impossible to recover?",
				"reset_subtitle": "Let us help you",
				"reset_title": "Impossible to recover?"
			},
			"business_kit": {
				"preview": "Preview Talentkit",
				"confirmation": "This confirms that information material has been requested and may be sent.",
				"history": "Talentkits sent",
				"send": "Send a Talentkit",
				"send_confirm": "Send Talentkit"
			},
			"button": {
				"double_optin": "Sure?",
				"external_forms": {
					"new": "Add a form"
				},
				"external_form": {
					"add_popup": "Add a form"
				},
				"lead_mask": {
					"save": "Save",
					"publish": "Publish"
				},
				"lead_masks": {
					"add_popup": "Add a talent sheet"
				},
				"opt-ins": {
					"new": "Add an opt-in"
				},
				"organizations": {
					"new": "Add an organization"
				},
				"email_templates": {
					"new": "Add a template"
				},
				"project_leads": {
					"add_popup": "Add talent",
					"confirm_mail": "Confirm email address",
					"confirm_picture": "Save & continue",
					"continue": "New Company",
					"create": "Add talent",
					"export": "Export xls",
					"make_another_picture": "Make another",
					"new": "Add talent",
					"take_picture": "Take a picture of a business card"
				},
				"projects": {
					"new": "Create a campaign"
				},
				"users": {
					"invite": "Invite",
					"invite_xls": "Invite via xls",
					"new": "Add a user",
					"upload_xls": "Proceed"
				},
				"workflows": {
					"new": "Create new workflow",
					"trigger": "Trigger workflow"
				}
			},
			"filters": {
				"apply": "Apply",
				"hint": "Filter search results",
				"import_origin": "Import origin",
				"origin": "Talent origin",
				"reset": "Reset",
				"start_date": "Start date",
				"sync_disabled": "CRM sync",
				"sync_status": "Sync status",
				"categories": "Categories"
			},
			"footer": {
				"imprint": "Imprint",
				"privacy": "Privacy",
				"terms": "Terms",
				"security": "Security"
			},
			"onboarding": {
				"next": "Next",
				"skip": "Skip",
				"start": "Start",
				"step1": {
					"title": "Create a Campaign",
					"subtitle": "Create a campaign in just a few clicks and start digitizing your next event or marketing campaign."
				},
				"step2": {
					"title": "Start Capturing Talent",
					"subtitle": "Create sign up forms and connect Talent's customizable web forms to your next digital Talent acquisition campaign."
				},
				"step3": {
					"title": "Create Content",
					"subtitle": "Create and distribute personalized digital content to enhance the nurturing process and  convert more talents to customers."
				}
			},
			"content_manager": {
				"first-card": {
					"title": "Talentkits",
					"subtitle": "Create an engaging and personalized content experience that helps genuinely connect with your company.",
					"btn": "Create a talentkit"
				},
				"second-card": {
					"title": "Forms",
					"subtitle": "Create custom web forms that connect directly to your existing marketing solutions (webinar tool, CRM,etc.) to onboard new prospects and automate the follow-up process.",
					"btn": "Create a form"
				},
				"third-card": {
					"title": "Talent Sheets",
					"subtitle": "Create a custom digital talent sheet to gather everything you need for the talent nurturing process.",
					"btn": "Contact support"
				}
			},
			"empty_state": {
				"projects": {
					"title": "Start Creating a New Campaign",
					"title-standard-user": "Welcome to Talent",
					"subtitle": "Digitize your talent acquisition process and start tracking your data all in one place.",
					"standard-user": "Please contact your admin to create a new campaign to get started."
				},
				"leads": {
					"title": "Start capturing talent for your next campaign.",
					"subtitle": "Capture the information you need to qualify and track new talent."
				}
			},
			"taglist": {
				"label": "Campaign Labels"
			},
			"global": {
				"add": "Add",
				"assign": "Assign",
				"back": "Back",
				"back_to_home": "Go back to the homepage",
				"cancel": "Cancel",
				"confirm": "Confirm",
				"continue": "Continue",
				"delete": "Delete",
				"delete_confirmation": "Are you sure you want to delete {name}?",
				"delete_title": "Delete this item?",
				"lead_edit_abort": "Do you really want to leave? There are unsaved changes!",
				"edit": "Edit",
				"empty_collection": "There are no items yet",
				"no_results": "Sorry, there are no results.",
				"no": "No",
				"save": "Save",
				"show": "Show",
				"take_picture": "Take a picture",
				"unassign": "Unassign",
				"valid": "Confirm",
				"yes": "Yes"
			},
			"header": {
				"add-lead": "Add a talent",
				"add-project": "Add a campaign"
			},
			"language": {
				"change": "Change language:",
				"de-tal": "DE",
				"en-tal": "EN /"
			},
			"menu": {
				"project_assignments_edit": "Assignments",
				"plans": "Plans",
				"profile": "Profile",
				"change-language": "Change language to German",
				"business_kits": "All Talentkits",
				"dashboard": "Dashboard",
				"external_forms": "Forms",
				"external_form_editor": "Editor",
				"external_form_options": "Options",
				"external_form_preview": "Preview",
				"general_settings": "General settings",
				"lead_masks": "Talent Sheets",
				"lead_mask_editor": "Editor",
				"lead_mask_options": "Options",
				"logout": "Logout",
				"businesskits": "Talentkits",
				"manage_projects": "Manage campaigns",
				"organizations": "Organizations",
				"project_edit": "Campaign settings",
				"project_leads": "Talents",
				"project_statistics": "Statistics",
				"projects": "Campaigns",
				"projects_synchronize": "Sync with CRM",
				"settings": "Manage users",
				"statistics": "Statistics",
				"trackings": "Trackings",
				"email_templates": "Email Templates",
				"user_profile": "Profile settings",
				"users": "Collaborators",
				"content_manager": "Content Manager"
			},
			"organizations": {
				"api": "External services",
				"configuration": "Configuration",
				"general_settings": "General settings"
			},
			"pages": {
				"businesskits": "All businesskits",
				"contact_us": "Contact us",
				"contact_us_email": "mailto:talent@fanomena.io?subject=Account%20recovery&body=Dear%20Fanomena%20Team%2C%0A%0AI%20am%20not%20able%20to%20log%20into%20my%20account%2C%20and%20have%20not%20been%20able%20to%20successfully%20reset%20my%20password.%20Can%20you%20please%20assist%20me%3F%0A%0ABest%2C",
				"email-templates": "Email templates",
				"email-templates-update": "Edit a template",
				"email-templates-create": "Create a template",
				"email-templates-new": "Create a template",
				"email-templates-create-button": "Create template",
				"email-templates-update-button": "Update template",
				"email-templates-new-button": "Create a template",
				"external-forms": "External forms",
				"external-forms--button": "Add a form",
				"external-forms-create-button": "Create form",
				"external-forms-update-button": "Edit form",
				"get_your_access": "Get your access",
				"item-create": "Create",
				"item-new": "New",
				"item-update": "Edit {name}",
				"lead-create": "Add talent to campaign",
				"lead-edit": "Edit a talent",
				"lead-mask-create-button": "Create talent sheet",
				"lead-mask-edit": "Edit {name}",
				"lead-mask-update-button": "Update talent sheet",
				"lead-masks": "Talent Sheets",
				"lead-no-businesskit": "There is no Talentkit assigned to this campaign",
				"lead-statistics": "Talent statistics",
				"lead-statistics-overview": "Overview",
				"lead-statistics-trackings": "Trackings",
				"lead-change-count": "Change made: {num} | Changes Made: {num}",
				"login": "Welcome",
				"login_details": "Enter you details to continue",
				"logout": "Thank you",
				"logout_details": "Thank you for using a product by Fanomena.",
				"opt-ins": "All opt-ins",
				"organization-edit": "Edit {name}",
				"organization-edit-button": "Update organization",
				"organization-new": "Create an organization",
				"organization-new-button": "Create organization",
				"organization-create-button": "Create organization",
				"organization-update-button": "Update organization",
				"organizations": "All organizations",
				"password_reset": "Enter your new password below",
				"password_reset_confirm": "Your password has been reset successfully",
				"password_reset_request": "Enter your email and we will send you a link, where you can recover your password",
				"password_reset_request_confirm": "An email with a password reset link has been sent to the given email if it exists.",
				"project-assign": "Assign to campaign",
				"project-assign-businesskit": "Assign Talenkits",
				"project-assign-user": "Assign collaborators",
				"project-assigned-businesskit": "Talentkits",
				"project-assigned-user": "Collaborators",
				"project-assignments": "Campaign assignments",
				"project-create": "Add a new campaign",
				"project-create-button": "Create campaign",
				"project-download-data": "Receive data as xls",
				"project-download-data-suceed": "The xls had been sent to your email address",
				"project-edit": "Edit {name}",
				"project-edit-user": "Edit",
				"project-options": "Campaign options",
				"project-show": "{name}",
				"project-update-button": "Save",
				"projects": "Campaigns",
				"statistic-show": "Statistic details: {name}",
				"statistics": "Statistics",
				"take_a_tour": "To the website",
				"user-edit": "Edit {name}",
				"user-edit-button": "Update collaborator",
				"user-invite": "Invite a collaborator",
				"user-new-button": "Add collaborator",
				"user-show": "collaborator: {name}",
				"user-update-button": "Update collaborator",
				"users": "Collaborators",
				"project-next-button": "Next",
				"project-capture-leads": "Go to campaign",
				"project-view-talentkit": "Go to Talentkit",
				"project-create-talentkit": "Create Talentkit",
				"project-create-content": "Create Content",
				"previous": "Back"
			},
			"project_wizard": {
				"step1-title": "Setup Campaign",
				"step2-title": "Choose Talentkit",
				"step2-invite-users": "Invite new collaborator to Fanomena Talent",
				"step2-assign-users": "Assign an existing Fanomena Talent user to this campaign",
				"businesskits": "Every campaign is connected to a Talentkit.",
				"lead-sheets": "Talent Sheets",
				"leadsheet-create": "Create Custom Talentkit",
				"leadsheet-create-tip": "Contact us if you are interested in creating a custom talent sheet.",
				"leadsheet-basic": "Digital talent sheet to capture personal and company talent details",
				"leadsheet-advanced": "Digital talent sheet that includes all standard talent sheet elements and additional questions to qualify your talent.",
				"success-title": "Congratulations, you have just created your first campaign!",
				"success-subtitle": "What would you like to do next?",
				"step2-invite": "To assign existing Talent users to this campaign, go to the Campaign Settings after setting up your campaign."
			},
			"searchbar": {
				"placeholder": {
					"bk": "Enter a talentkit name…",
					"email_templates": "Enter a specific name…",
					"external_forms": "Enter a specific name or campaign…",
					"lead_masks": "Enter a specific name…",
					"organizations": "Enter a specific organization name…",
					"projects": "Search for a campaign…",
					"contacts": "Search for a contact…",
					"project_leads": "Search for a talent…",
					"users": "Enter a firstname, lastname or email…"
				}
			},
			"tabs": {
				"company_tab": "Company",
				"kits_tab": "Kits",
				"personal_tab": "Personal",
				"qualify_tab": "Qualify",
				"stats_tab": "Stats"
			},
			"upload": {
				"dropzone_message": "Drag files or click to upload a file",
				"empty_file": "Remove the file"
			},
			"users": {
				"invite": "Invite a collaborator",
				"invite_xls_success": "Users were succesfully invited",
				"xls_invite": "Invite via xls",
				"xls_invite_description": "You can provide a CSV file containing the user you want to invite. They will receive an invitation email.",
				"xls_invite_format": "The file should contain at least three columns: firstname, lastname and email. Only the email is mandatory but first name and last name are highly recommended."
			},
			"integrations": {
				"go-to-webinar": "Automatically add all talent that fills out your form to a webinar"
			},
			"modals": {
				"businesskit_assignment": {
					"title": "Manage Talentkits",
					"subtitle": "Select the Talentktis that you want to assign to the current campaign"
				},
				"user_assignment": {
					"title": "Manage collaborators",
					"subtitle": "Select the collaborators that you want to assign to the current campaign."
				},
				"workflow": {
					"create": {
						"title": "Create a workflow"
					}
				},
				"warning": {
					"button": "I understand"
				}
			},
			"drag_editor": {
				"extra_values": "and {num} extra.",
				"unpublished_changes": "There are unpublished changes",
				"popup": {
					"unsaved_changes": "You have unsaved changes. Do you really wish to leave?"
				},
				"active_item": {
					"edit": "Edit selected element",
					"label": "Label",
					"value": "Value"
				},
				"fields": {
					"add_item": "Add item",
					"label": "Label",
					"text": "Text",
					"placeholder": "Placeholder text",
					"required": "Make this field required",
					"hidden": "Make this field hidden",
					"class": "CSS class",
					"default_value": "Default value",
					"default_value_options": "Preselect",
					"validation": "Error message",
					"internal_name": "Internal name",
					"show_as_buttons": "Show elements in button style",
					"enrich_tags": "Save selection as tags",
					"data_type": "Data type",
					"data_types": {
						"text": "Text",
						"number": "Number",
						"email": "Email",
						"tel": "Telephone number",
						"url": "Url"
					}
				},
				"dragElements": {
					"generic": "Generic Elements",
					"leadMask": "Talent Sheet Elements",
					"basic": "Basic elements",
					"fields": "Fields",
					"advanced": "Custom fields",
					"standard": "Standard fields"
				},
				"badges": {
					"hidden": "Hidden Field"
				},
				"placeholders": {
					"anchor": "Link",
					"bold": "Bold",
					"italic": "Italic",
					"underline": "Underline"
				},
				"screenTooSmall": {
					"title": "Sorry!",
					"subtitle": "In order to use our editor please switch to a higher resolution."
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/talents/ui.en-tal.yml
// module id = 2043
// module chunks = 0